var ko = require('knockout');
var sortBy = require('lodash/sortBy');
var groupBy = require('lodash/groupBy');
var forIn = require('lodash/forIn');

var chunk = require('_utils/chunk');

function CourseInstructors(params) {
  var self = this;
  var instructorsData = params;

  if (!instructorsData) {
    return;
  }

  this.sortFirstName = ko.observable(true);
  this.currentPage = ko.observable(1);
  this.maxItemsPerPage = ko.observable(15);
  this.amountOfItems = ko.observable(instructorsData.instructors.length);

  // Amount of pages with items.
  this.pages = ko.computed(function() {
    var pages = self.amountOfItems() / self.maxItemsPerPage();
    if (pages < 1) {
      pages = 1;
    }
    return Math.ceil(pages);
  });

  this.totalInstructors = instructorsData.totalInstructors;
  this.instructors = instructorsData.instructors;

  // Sort by first name
  this.instructorsSortedFirst = sortBy(this.instructors, 'Name');
  // Sort by last name
  this.instructorsSortedLast = sortBy(this.instructors, function(instructor) {
    var names = instructor.Name.split(' ');
    // Get the last name so we can sort by it.
    return names[names.length - 1];
  });

  // Divide the sorted array into chunks (more arrays), where each chunk represents a page.
  this.pagesSortedFirst = chunk(
    this.instructorsSortedFirst,
    this.maxItemsPerPage()
  );
  this.pagesSortedLast = chunk(
    this.instructorsSortedLast,
    this.maxItemsPerPage()
  );

  // Group the chunks by the first character in their first/last name.
  this.groupedSortedFirst = this._groupSortedList(this.pagesSortedFirst, false);
  this.groupedSortedLast = this._groupSortedList(this.pagesSortedLast, true);

  // Format it into something knockout can work with.
  this.instructorsAZ = ko.observableArray(
    this._formatForKnockout(this.groupedSortedFirst)
  );
  this.instructorsZA = ko.observableArray(
    this._formatForKnockout(this.groupedSortedLast)
  );

  // This is list that will change according to the sort method. Default is A to Z (/Å).
  this.instructorsList = ko.observableArray(this.instructorsAZ());

  // This is the list we're actually displaying.
  this.activeList = ko.computed(function() {
    return this.instructorsList()[this.currentPage() - 1];
  }, this);
}

CourseInstructors.prototype._groupSortedList = function(
  sortedList,
  groupByLastName
) {
  var retArray = [];

  sortedList.forEach(function(list) {
    retArray.push(
      groupBy(list, function(instructor) {
        if (groupByLastName) {
          var names = instructor.Name.split(' ');
          return names[names.length - 1].charAt(0);
        } else {
          return instructor.Name.charAt(0);
        }
      })
    );
  });

  return retArray;
};

CourseInstructors.prototype._formatForKnockout = function(groupedList) {
  var retArray = [];
  groupedList.forEach(function(list) {
    var newArr = [];
    forIn(list, function(value, key) {
      newArr.push({
        letter: key,
        names: value
      });
    });
    retArray.push(newArr);
    newArr = [];
  });

  return retArray;
};

CourseInstructors.prototype.sort = function(asc) {
  this.sortFirstName(asc);
  if (asc) {
    this.instructorsList(this.instructorsAZ());
  } else {
    this.instructorsList(this.instructorsZA());
  }
};

// Will loop through the list items to find the tallest list item and
// set all other list items to this height.
CourseInstructors.prototype.setListItemHeight = function(list) {
  var listItems = $(list).find('.course-instructor-item');
  var i = 0,
    maxHeight = 0,
    newHeight = 0;
  for (i = 0; i < listItems.length; i++) {
    $(listItems[i]).outerHeight('auto');
    newHeight = $(listItems[i]).outerHeight();
    if (newHeight > maxHeight) {
      maxHeight = newHeight;
    }
  }
  for (i = 0; i < listItems.length; i++) {
    $(listItems[i]).outerHeight(maxHeight + 'px');
  }
};

// Called after activeList has been rendered to DOM. Using the ko template "hack".
CourseInstructors.prototype.setListsItemHeight = function(element) {
  var lists = $(element)
      .siblings('.course-content-container')
      .find('.course-instructors-list'),
    self = this;

  function loopList() {
    for (var i = 0; i < lists.length; i++) {
      self.setListItemHeight(lists[i]);
    }
  }
  $(window).on('resize', function() {
    loopList();
  });
  loopList();
};

module.exports = CourseInstructors;
